<input #phoneInput id="phone" type="tel" class="phone-input input" placeholder="Ex- 9898******" [appMaxLength]="15"/>
